import { useQuery } from "react-query";
import { getOfficeStatus } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeStatus = () => {
    return useQuery("OfficeStatus", getOfficeStatus, {
    refetchOnWindowFocus: false,
  });
};